import { c, msgid } from 'ttag';

import { validateEmailAddress } from './email';
import { isNumber } from './validators';

export const requiredValidator = (value: any) =>
    value === undefined || value === null || value?.trim?.() === '' ? c('Error').t`This field is required` : '';
export const minLengthValidator = (value: string, minimumLength: number) =>
    value.length < minimumLength ? c('Error').t`This field requires a minimum of ${minimumLength} characters.` : '';
export const emailValidator = (value: string) => (!validateEmailAddress(value) ? c('Error').t`Email is not valid` : '');
export const numberValidator = (value: string) => (!isNumber(value) ? c('Error').t`Not a valid number` : '');
export const confirmPasswordValidator = (a: string, b: string) => (a !== b ? c('Error').t`Passwords do not match` : '');
export const defaultMinPasswordLength = 12;
export const getMinPasswordLengthMessage = (length = defaultMinPasswordLength) =>
    c('Validation').ngettext(
        msgid`Password must contain at least ${length} character`,
        `Password must contain at least ${length} characters`,
        length
    );
export const passwordLengthValidator = (a: string, length = defaultMinPasswordLength) =>
    a.length < length ? getMinPasswordLengthMessage() : '';
export const passwordCapitalizeValidator = (a: string) =>
    a.match(/([A-Z])/) ? '' : c('Error').t`Password required at least 1 uppercase`;
export const passwordLowerValidator = (a: string) =>
    a.match(/([a-z])/) ? '' : c('Error').t`Password required at least 1 lowercase`;
export const passwordNumberValidator = (a: string) =>
    a.match(/([0-9])/) ? '' : c('Error').t`Password required at least 1 number`;
export const passwordSpecialCharValidator = (a: string) =>
    a.match(/([+#?!@$%^&*-])/) ? '' : c('Error').t`Password required at least 1 special char`;
/**
 * Attention, the length comes from `defaultMinPasswordLength`, it is not written again.
 *
 * It used to be a literal `8` while the constant said 12, the checklist under the
 * field showed « 12 chars » with a red cross, and the Cognito pool refused anything
 * shorter. A nine-character password therefore passed the form and was refused by
 * the server: the field said yes, the checklist said no, and the pool had the last
 * word. Three sources for one rule is two too many.
 */
const passwordRule = new RegExp(
    `^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[+#?!@$%^&*-]).{${defaultMinPasswordLength},}$`
);

export const passwordValidator = (a: string) =>
    a.match(passwordRule) ? '' : c('Error').t`Password must match security rules`;
